import { Component, Input, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subject, debounceTime } from "rxjs";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { RestrictedAccessComponent } from "../restricted-access/restricted-access.component";
import { DataService } from "src/app/Services/dataservice.service";
import { AuthModalService } from "src/app/Services/auth-modal.service";

@Component({
  selector: "app-user-list-dialog",
  templateUrl: "./user-list-dialog.component.html",
  styleUrls: ["./user-list-dialog.component.scss"],
})
export class UserListDialogComponent implements OnInit {
  @Input() recordType!: string; // Input property for the name of the record to be deleted
  private searchTerms = new Subject<string>();
  flowModel: any;
  userData: any;
  userDisplayName: any;
  allUsers: any[];
  tempUsers: any[];
  input: any;
  email: any;
  showUsers: boolean;
  isdisabled: boolean;
  noResultReturned: boolean;

  constructor(
    private userserviceService: UserserviceService,
    private router: Router,

    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    public dialogRef: MatDialogRef<RestrictedAccessComponent>,
    public authModalService: AuthModalService
  ) {
    this.flowModel = JSON.parse(localStorage.getItem("flowModel"));
    this.searchTerms
      .pipe(debounceTime(2000)) // Adjust the debounce time as needed
      .subscribe(() => {
        // Call your search function here
        this.performUsersSearch(0);
      });
  }

  performUsersSearch(pageIndex) {
    this.noResultReturned = true;
    this.allUsers = [];
    this.tempUsers = [];
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      this.showUsers = false;
      email = this.userData.emailAddress;
    }
    this.showUsers = true;
    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    this.userserviceService.searchInUsers(flowQueryModel).subscribe((data) => {
      this.noResultReturned = false;

      if (data.allUsers.length > 0) {
        this.tempUsers = [];
        this.allUsers = [];
        data.allUsers.forEach((element) => {
          console.log(element);
          const user = {
            user: element,
            IsAccessGiven: false,
            EmailAddress: element.emailAddress,
          };
          this.allUsers.push(user);
        });

        this.tempUsers = this.allUsers;
        console.log(this.tempUsers);
        this.tempUsers.forEach((element) => {
          if (element.followButtonText === "Following") {
            element.followButtonText = "Following";
            element.followingcolor = "black";
            element.followingbgcolor = "white";
          } else {
            element.followButtonText = "Follow";
            element.followingcolor = "white";
            element.followingbgcolor = "#5ea1d8";
          }
        });
      }
    });
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    } else {
      this.checkIsUserLoggedIn();
    }
    this.allUsers = [];
    this.tempUsers = [];
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");

    this.getPaginatedUsers(undefined, "0");
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }

  getPaginatedUsers(infiniteScroll, pageIndex) {
    var email = "";

    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.performUsersSearch(pageIndex);
    } else {
      this.userserviceService.getAllUsers(flowQueryModel).subscribe((data) => {
        if (data.allUsers.length > 0) {
          this.tempUsers = [];
          data.allUsers.forEach((element) => {
            const user = {
              FlowId: element.rowKey,
              user: element,
              UserName: element.userName,
              ProfilePicUrl: element.profilePicUrl,
              FirstName: element.firstName,
              EmailAddress: element.emailAddress,
              showFollow: false,
              followButtonText: element.followingText,
            };
            this.allUsers.push(user);
          });
          this.tempUsers = this.allUsers;
          console.log(this.tempUsers);
          this.tempUsers.forEach((element) => {
            if (element.followButtonText === "Following") {
              element.followButtonText = "Following";
              element.followingcolor = "black";
              element.followingbgcolor = "white";
            } else {
              element.followButtonText = "Follow";
              element.followingcolor = "white";
              element.followingbgcolor = "#5ea1d8";
            }
          });
        }
      });
      this.showUsers = false;
    }
  }

  getAllUsers() {
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");

    this.allUsers = [];
    this.tempUsers = [];
    this.getPaginatedUsers(undefined, "0");
    console.log(this.tempUsers);
  }

  viewUserProfile(selectedUser) {
    if (this.userData != null) {
      if (
        this.userData.emailAddress === selectedUser.customerEmail ||
        this.userData.emailAddress === selectedUser.emailAddress
      ) {
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedUser);
    } else {
      // Open login modal instead of navigating to page
      this.authModalService.openModal('login', this.router.url);
    }
  }

  accessChanged() {
    var value = this.allUsers.filter((x) => x.IsAccessGiven)[0];
    console.log(value);
    if (value != this.recordType) {
      value.user.userRole = this.recordType;
      value.user.isAdmin = this.recordType == "User" ? false : true;
    }
  }

  submitUserListToUpdateRoles() {
    const filteredUsers = this.allUsers.filter((user) => user.IsAccessGiven);
    this.dialogRef.close(filteredUsers);
  }

  close() {
    this.allUsers = [];
    this.dialogRef.close(this.allUsers);
  }

  searchUsers() {
    this.searchTerms.next(this.input);
  }
}
